import { useCloseOnOutsideClick as t } from "./utils/useCloseOnOutsideClick.mjs";
export {
  t as useCloseOnOutsideClick
};
